/* eslint-disable */
// DO NOT EDIT THIS FILE. THIS IS AUTOGENERATED WITH GRAPHQL CODEGEN.
export type Maybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSDateTime` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 DateTime](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) string. In other words, this scalar type accepts datetime strings of the form `YYYY-MM-DDThh:mm:ss.SSSZ`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-01-01T00:00Z**" and "**-9999-01-01T00:00Z**" are both valid datetime strings.  The field after the two digit seconds field is a nanoseconds field. It can accept between 1 and 9 digits. So, for example, "**1970-01-01T12:00:00.2Z**", "**1970-01-01T12:00:00.277Z**" and "**1970-01-01T12:00:00.123456789Z**" are all valid datetime strings.  The seconds and nanoseconds fields are optional (the seconds field must be specified if the nanoseconds field is to be used).  The [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators) is compulsory for this scalar. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDateTime: any;
};

export type Airtable = {
  __typename?: 'Airtable';
  assignedOperator?: Maybe<Scalars['String']>;
  cueSheetUrl?: Maybe<Scalars['String']>;
  eventId: Scalars['Int'];
  eventOperatorNotes?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  operatorNotes?: Maybe<Scalars['String']>;
  operatorType?: Maybe<Scalars['String']>;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomPassword?: Maybe<Scalars['String']>;
};

export type Asset = {
  __typename?: 'Asset';
  client_id?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  is_live?: Maybe<Scalars['Boolean']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_status?: Maybe<Scalars['String']>;
  mux_stream_id?: Maybe<Scalars['String']>;
  scheduled_end?: Maybe<Scalars['String']>;
  scheduled_event_id?: Maybe<Scalars['Int']>;
  scheduled_time?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type AssetInput = {
  client_id?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  is_live?: Maybe<Scalars['Boolean']>;
  mux_asset_id?: Maybe<Scalars['String']>;
  mux_playback_id?: Maybe<Scalars['String']>;
  mux_status?: Maybe<Scalars['String']>;
  mux_stream_id?: Maybe<Scalars['String']>;
  scheduled_end?: Maybe<Scalars['String']>;
  scheduled_event_id?: Maybe<Scalars['Int']>;
  scheduled_time?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type Client = {
  __typename?: 'Client';
  backgroundUrl?: Maybe<Scalars['String']>;
  cid: Scalars['String'];
  contacts?: Maybe<Array<Maybe<TroubleshootingContact>>>;
  createdAt?: Maybe<Scalars['String']>;
  creditBalance?: Maybe<Scalars['Int']>;
  donateLink?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eventOperatorNotes?: Maybe<Scalars['String']>;
  facebookApiKey?: Maybe<Scalars['String']>;
  hasArchive?: Maybe<Scalars['Boolean']>;
  hasAutoplay?: Maybe<Scalars['Boolean']>;
  hasChat?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  industryId?: Maybe<Scalars['Int']>;
  leadTime?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  organizationAddress?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  organizationZipCode?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  subscriptionStatus?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  webplayerClientId?: Maybe<Scalars['Int']>;
  webplayerName?: Maybe<Scalars['String']>;
  youtubeApiKey?: Maybe<Scalars['String']>;
};

export type ClientInput = {
  backgroundUrl?: Maybe<Scalars['String']>;
  cid: Scalars['String'];
  contacts?: Maybe<Array<Maybe<TroubleshootingContactInput>>>;
  createdAt?: Maybe<Scalars['String']>;
  creditBalance?: Maybe<Scalars['Int']>;
  donateLink?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eventOperatorNotes?: Maybe<Scalars['String']>;
  facebookApiKey?: Maybe<Scalars['String']>;
  hasArchive?: Maybe<Scalars['Boolean']>;
  hasAutoplay?: Maybe<Scalars['Boolean']>;
  hasChat?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  industryId?: Maybe<Scalars['Int']>;
  leadTime?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  organizationAddress?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  organizationZipCode?: Maybe<Scalars['String']>;
  paymentToken?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  subscriptionStatus?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  webplayerClientId?: Maybe<Scalars['Int']>;
  webplayerName?: Maybe<Scalars['String']>;
  youtubeApiKey?: Maybe<Scalars['String']>;
};

export type CognitoUserDeleted = {
  __typename?: 'CognitoUserDeleted';
  id: Scalars['String'];
};

export type CreateDestinationInput = {
  active?: Maybe<Scalars['Boolean']>;
  destinationPlayerUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrationId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  scheduledEventDestinationsId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  streamBroadcastId?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
  streamPassthrough?: Maybe<Scalars['String']>;
  streamSecondaryBroadcastId?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  type?: Maybe<DestinationType>;
};

export type CreateScheduledEventInput = {
  assets?: Maybe<Array<Maybe<AssetInput>>>;
  backgroundUrl?: Maybe<Scalars['String']>;
  cid: Scalars['String'];
  client?: Maybe<ClientInput>;
  cronFlag?: Maybe<Scalars['Int']>;
  cueSheetUrl?: Maybe<Scalars['String']>;
  currentMuxStreamUrl?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['AWSDateTime']>;
  dateUpdated?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  distributions: Array<Distribution>;
  eid: Scalars['String'];
  endTime: Scalars['AWSDateTime'];
  eventPassword?: Maybe<Scalars['String']>;
  eventType: EventType;
  hidden: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  isLive: Scalars['Boolean'];
  isOperated?: Maybe<Scalars['Boolean']>;
  isSimulatedLive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  muxDashboardUrl?: Maybe<Scalars['String']>;
  muxIds?: Maybe<MuxIdsInput>;
  muxStatus?: Maybe<Scalars['String']>;
  muxStreamUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationSent?: Maybe<Scalars['Boolean']>;
  operatorNotes?: Maybe<Scalars['String']>;
  organizationName: Scalars['String'];
  recordOnly: Scalars['Boolean'];
  simulatedLiveAssetId?: Maybe<Scalars['Int']>;
  simulatedLiveFilename?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['AWSDateTime']>;
  status: Scalars['String'];
  streamFacebook: Scalars['Boolean'];
  streamLive: Scalars['Boolean'];
  streamRtmp?: Maybe<Scalars['Boolean']>;
  streamYoutube: Scalars['Boolean'];
  streamZoom: Scalars['Boolean'];
  visibility: EventVisibility;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomPassword?: Maybe<Scalars['String']>;
};

export type CreateUser = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type DeleteDestinationInput = {
  id: Scalars['ID'];
};

export type DeleteScheduledEventInput = {
  eid: Scalars['String'];
};

export type Destination = {
  __typename?: 'EventDestination';
  active?: Maybe<Scalars['Boolean']>;
  // createdAt: Scalars['AWSDateTime'];
  destinationPlayerUrl?: Maybe<Scalars['String']>;
  // id: Scalars['String'];
  // integrationId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  // scheduledEvent?: Maybe<ScheduledEvent>;
  // scheduledEventDestinationsId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  streamBroadcastId?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
  streamPasstrough?: Maybe<Scalars['String']>;
  // streamPassthrough?: Maybe<Scalars['String']>;
  streamSecondaryBroadcastId?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  type?: Maybe<DestinationType>;
  // updatedAt: Scalars['AWSDateTime'];
};

export enum DestinationType {
  Facebook = 'Facebook',
  LiveControl = 'LiveControl',
  Rtmp = 'RTMP',
  YouTube = 'YouTube'
}

export enum Distribution {
  Facebook = 'Facebook',
  WebPlayer = 'WebPlayer',
  YouTube = 'YouTube'
}

export enum EventType {
  ClientBookingMobilePremium = 'ClientBookingMobilePremium',
  ClientBookingPremium = 'ClientBookingPremium',
  ClientBookingStandard = 'ClientBookingStandard',
  Mobile = 'Mobile',
  MobileKit = 'Mobile Kit',
  Produced = 'Produced',
  SimLive = 'SimLive',
  Static = 'Static',
  Test = 'Test'
}

export enum EventVisibility {
  Private = 'Private',
  Public = 'Public'
}

export type Group = {
  __typename?: 'Group';
  name: Scalars['String'];
  precedence: Scalars['Int'];
};

export enum ModelAttributeTypes {
  Null = '_null',
  Binary = 'binary',
  BinarySet = 'binarySet',
  Bool = 'bool',
  List = 'list',
  Map = 'map',
  Number = 'number',
  NumberSet = 'numberSet',
  String = 'string',
  StringSet = 'stringSet'
}

export type ModelBooleanInput = {
  attributeExists?: Maybe<Scalars['Boolean']>;
  attributeType?: Maybe<ModelAttributeTypes>;
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
};

export type ModelDestinationConditionInput = {
  active?: Maybe<ModelBooleanInput>;
  and?: Maybe<Array<Maybe<ModelDestinationConditionInput>>>;
  destinationPlayerUrl?: Maybe<ModelStringInput>;
  id?: Maybe<ModelStringInput>;
  integrationId?: Maybe<ModelStringInput>;
  name?: Maybe<ModelStringInput>;
  not?: Maybe<ModelDestinationConditionInput>;
  or?: Maybe<Array<Maybe<ModelDestinationConditionInput>>>;
  scheduledEventDestinationsId?: Maybe<ModelIdInput>;
  status?: Maybe<ModelStringInput>;
  streamBroadcastId?: Maybe<ModelStringInput>;
  streamKey?: Maybe<ModelStringInput>;
  streamPassthrough?: Maybe<ModelStringInput>;
  streamSecondaryBroadcastId?: Maybe<ModelStringInput>;
  streamUrl?: Maybe<ModelStringInput>;
  type?: Maybe<ModelDestinationTypeInput>;
};

export type ModelDestinationFilterInput = {
  active?: Maybe<ModelBooleanInput>;
  and?: Maybe<Array<Maybe<ModelDestinationFilterInput>>>;
  destinationPlayerUrl?: Maybe<ModelStringInput>;
  id?: Maybe<ModelStringInput>;
  integrationId?: Maybe<ModelStringInput>;
  name?: Maybe<ModelStringInput>;
  not?: Maybe<ModelDestinationFilterInput>;
  or?: Maybe<Array<Maybe<ModelDestinationFilterInput>>>;
  scheduledEventDestinationsId?: Maybe<ModelIdInput>;
  status?: Maybe<ModelStringInput>;
  streamBroadcastId?: Maybe<ModelStringInput>;
  streamKey?: Maybe<ModelStringInput>;
  streamPassthrough?: Maybe<ModelStringInput>;
  streamSecondaryBroadcastId?: Maybe<ModelStringInput>;
  streamUrl?: Maybe<ModelStringInput>;
  type?: Maybe<ModelDestinationTypeInput>;
};

export type ModelDestinationTypeInput = {
  eq?: Maybe<DestinationType>;
  ne?: Maybe<DestinationType>;
};

export type ModelDistributionInput = {
  eq?: Maybe<Distribution>;
  ne?: Maybe<Distribution>;
};

export type ModelEventTypeInput = {
  eq?: Maybe<EventType>;
  ne?: Maybe<EventType>;
};

export type ModelEventVisibilityInput = {
  eq?: Maybe<EventVisibility>;
  ne?: Maybe<EventVisibility>;
};

export type ModelFloatInput = {
  attributeExists?: Maybe<Scalars['Boolean']>;
  attributeType?: Maybe<ModelAttributeTypes>;
  between?: Maybe<Array<Maybe<Scalars['Float']>>>;
  eq?: Maybe<Scalars['Float']>;
  ge?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  le?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
};

export type ModelIdInput = {
  attributeExists?: Maybe<Scalars['Boolean']>;
  attributeType?: Maybe<ModelAttributeTypes>;
  beginsWith?: Maybe<Scalars['ID']>;
  between?: Maybe<Array<Maybe<Scalars['ID']>>>;
  contains?: Maybe<Scalars['ID']>;
  eq?: Maybe<Scalars['ID']>;
  ge?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  le?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  notContains?: Maybe<Scalars['ID']>;
  size?: Maybe<ModelSizeInput>;
};

export type ModelIntInput = {
  attributeExists?: Maybe<Scalars['Boolean']>;
  attributeType?: Maybe<ModelAttributeTypes>;
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
  eq?: Maybe<Scalars['Int']>;
  ge?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  le?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
};

export type ModelScheduledEventConditionInput = {
  and?: Maybe<Array<Maybe<ModelScheduledEventConditionInput>>>;
  backgroundUrl?: Maybe<ModelStringInput>;
  cid?: Maybe<ModelStringInput>;
  cronFlag?: Maybe<ModelIntInput>;
  cueSheetUrl?: Maybe<ModelStringInput>;
  currentMuxStreamUrl?: Maybe<ModelStringInput>;
  dateCreated?: Maybe<ModelStringInput>;
  dateUpdated?: Maybe<ModelStringInput>;
  description?: Maybe<ModelStringInput>;
  distributions?: Maybe<ModelDistributionInput>;
  endTime?: Maybe<ModelStringInput>;
  eventPassword?: Maybe<ModelStringInput>;
  eventType?: Maybe<ModelEventTypeInput>;
  hidden?: Maybe<ModelBooleanInput>;
  isLive?: Maybe<ModelBooleanInput>;
  isOperated?: Maybe<ModelBooleanInput>;
  isSimulatedLive?: Maybe<ModelBooleanInput>;
  locationId?: Maybe<ModelStringInput>;
  locationName?: Maybe<ModelStringInput>;
  muxDashboardUrl?: Maybe<ModelStringInput>;
  muxStatus?: Maybe<ModelStringInput>;
  muxStreamUrl?: Maybe<ModelStringInput>;
  name?: Maybe<ModelStringInput>;
  not?: Maybe<ModelScheduledEventConditionInput>;
  notificationSent?: Maybe<ModelBooleanInput>;
  operatorNotes?: Maybe<ModelStringInput>;
  or?: Maybe<Array<Maybe<ModelScheduledEventConditionInput>>>;
  organizationName?: Maybe<ModelStringInput>;
  recordOnly?: Maybe<ModelBooleanInput>;
  simulatedLiveAssetId?: Maybe<ModelIntInput>;
  simulatedLiveFilename?: Maybe<ModelStringInput>;
  startTime?: Maybe<ModelStringInput>;
  status?: Maybe<ModelStringInput>;
  streamFacebook?: Maybe<ModelBooleanInput>;
  streamLive?: Maybe<ModelBooleanInput>;
  streamRtmp?: Maybe<ModelBooleanInput>;
  streamYoutube?: Maybe<ModelBooleanInput>;
  streamZoom?: Maybe<ModelBooleanInput>;
  visibility?: Maybe<ModelEventVisibilityInput>;
  zoomMeetingId?: Maybe<ModelStringInput>;
  zoomPassword?: Maybe<ModelStringInput>;
};

export type ModelScheduledEventConnection = {
  __typename?: 'ModelScheduledEventConnection';
  items: Array<Maybe<ScheduledEvent>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ModelScheduledEventFilterInput = {
  and?: Maybe<Array<Maybe<ModelScheduledEventFilterInput>>>;
  backgroundUrl?: Maybe<ModelStringInput>;
  cid?: Maybe<ModelStringInput>;
  cronFlag?: Maybe<ModelIntInput>;
  cueSheetUrl?: Maybe<ModelStringInput>;
  currentMuxStreamUrl?: Maybe<ModelStringInput>;
  dateCreated?: Maybe<ModelStringInput>;
  dateUpdated?: Maybe<ModelStringInput>;
  description?: Maybe<ModelStringInput>;
  distributions?: Maybe<ModelDistributionInput>;
  eid?: Maybe<ModelStringInput>;
  endTime?: Maybe<ModelStringInput>;
  eventPassword?: Maybe<ModelStringInput>;
  eventType?: Maybe<ModelEventTypeInput>;
  hidden?: Maybe<ModelBooleanInput>;
  id?: Maybe<ModelStringInput>;
  isLive?: Maybe<ModelBooleanInput>;
  isOperated?: Maybe<ModelBooleanInput>;
  isSimulatedLive?: Maybe<ModelBooleanInput>;
  locationId?: Maybe<ModelStringInput>;
  locationName?: Maybe<ModelStringInput>;
  muxDashboardUrl?: Maybe<ModelStringInput>;
  muxStatus?: Maybe<ModelStringInput>;
  muxStreamUrl?: Maybe<ModelStringInput>;
  name?: Maybe<ModelStringInput>;
  not?: Maybe<ModelScheduledEventFilterInput>;
  notificationSent?: Maybe<ModelBooleanInput>;
  operatorNotes?: Maybe<ModelStringInput>;
  or?: Maybe<Array<Maybe<ModelScheduledEventFilterInput>>>;
  organizationName?: Maybe<ModelStringInput>;
  recordOnly?: Maybe<ModelBooleanInput>;
  simulatedLiveAssetId?: Maybe<ModelIntInput>;
  simulatedLiveFilename?: Maybe<ModelStringInput>;
  startTime?: Maybe<ModelStringInput>;
  status?: Maybe<ModelStringInput>;
  streamFacebook?: Maybe<ModelBooleanInput>;
  streamLive?: Maybe<ModelBooleanInput>;
  streamRtmp?: Maybe<ModelBooleanInput>;
  streamYoutube?: Maybe<ModelBooleanInput>;
  streamZoom?: Maybe<ModelBooleanInput>;
  visibility?: Maybe<ModelEventVisibilityInput>;
  zoomMeetingId?: Maybe<ModelStringInput>;
  zoomPassword?: Maybe<ModelStringInput>;
};

export type ModelSizeInput = {
  between?: Maybe<Array<Maybe<Scalars['Int']>>>;
  eq?: Maybe<Scalars['Int']>;
  ge?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  le?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
};

export enum ModelSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ModelStringInput = {
  attributeExists?: Maybe<Scalars['Boolean']>;
  attributeType?: Maybe<ModelAttributeTypes>;
  beginsWith?: Maybe<Scalars['String']>;
  between?: Maybe<Array<Maybe<Scalars['String']>>>;
  contains?: Maybe<Scalars['String']>;
  eq?: Maybe<Scalars['String']>;
  ge?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  le?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  notContains?: Maybe<Scalars['String']>;
  size?: Maybe<ModelSizeInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createDestination?: Maybe<Destination>;
  createScheduledEvent?: Maybe<ScheduledEvent>;
  createUser?: Maybe<User>;
  defconCacheRefresh?: Maybe<SuccessType>;
  defconCacheRefreshAndSignal?: Maybe<SuccessType>;
  defconForceBrowserRefresh?: Maybe<SuccessType>;
  defconForceEndStream?: Maybe<SuccessType>;
  defconNuclearRefresh?: Maybe<SuccessType>;
  deleteDestination?: Maybe<Destination>;
  deleteScheduledEvent?: Maybe<ScheduledEvent>;
  deleteUser?: Maybe<CognitoUserDeleted>;
  updateDestination?: Maybe<Destination>;
  updateScheduledEvent?: Maybe<ScheduledEvent>;
  updateUser?: Maybe<User>;
  upsertAirtable?: Maybe<Airtable>;
};


export type MutationCreateDestinationArgs = {
  condition?: Maybe<ModelDestinationConditionInput>;
  input: CreateDestinationInput;
};


export type MutationCreateScheduledEventArgs = {
  condition?: Maybe<ModelScheduledEventConditionInput>;
  input: CreateScheduledEventInput;
};


export type MutationCreateUserArgs = {
  user?: Maybe<CreateUser>;
};


export type MutationDefconCacheRefreshArgs = {
  eid: Scalars['String'];
};


export type MutationDefconCacheRefreshAndSignalArgs = {
  eid: Scalars['String'];
};


export type MutationDefconForceBrowserRefreshArgs = {
  eid: Scalars['String'];
};


export type MutationDefconForceEndStreamArgs = {
  eid: Scalars['String'];
};


export type MutationDefconNuclearRefreshArgs = {
  eid: Scalars['String'];
};


export type MutationDeleteDestinationArgs = {
  condition?: Maybe<ModelDestinationConditionInput>;
  input: DeleteDestinationInput;
};


export type MutationDeleteScheduledEventArgs = {
  condition?: Maybe<ModelScheduledEventConditionInput>;
  input: DeleteScheduledEventInput;
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationUpdateDestinationArgs = {
  condition?: Maybe<ModelDestinationConditionInput>;
  input: UpdateDestinationInput;
};


export type MutationUpdateScheduledEventArgs = {
  condition?: Maybe<ModelScheduledEventConditionInput>;
  input: UpdateScheduledEventInput;
};


export type MutationUpdateUserArgs = {
  user?: Maybe<UpdateUser>;
};


export type MutationUpsertAirtableArgs = {
  airtable?: Maybe<UpsertAirtableInput>;
};

export type MuxIds = {
  __typename?: 'MuxIds';
  muxAssetId?: Maybe<Scalars['String']>;
  muxPlaybackId?: Maybe<Scalars['String']>;
  muxStreamId?: Maybe<Scalars['String']>;
};

export type MuxIdsInput = {
  muxAssetId?: Maybe<Scalars['String']>;
  muxPlaybackId?: Maybe<Scalars['String']>;
  muxStreamId?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getDestination?: Maybe<Destination>;
  getScheduledEvent?: Maybe<ScheduledEvent>;
  listAirtable?: Maybe<Airtable>;
  listDestinations?: Array<Maybe<Destination>>;
  listScheduledEvents?: Maybe<ModelScheduledEventConnection>;
  listUser?: Maybe<User>;
  listUsers?: Maybe<Array<Maybe<User>>>;
  searchScheduledEvents?: Maybe<SearchableScheduledEventConnection>;
};


export type QueryGetDestinationArgs = {
  id: Scalars['ID'];
};


export type QueryGetScheduledEventArgs = {
  eid: Scalars['String'];
};


export type QueryListAirtableArgs = {
  eventId?: Maybe<Scalars['String']>;
};


export type QueryListDestinationsArgs = {
  filter?: Maybe<ModelDestinationFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
};


export type QueryListScheduledEventsArgs = {
  eid?: Maybe<Scalars['String']>;
  filter?: Maybe<ModelScheduledEventFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<ModelSortDirection>;
};


export type QueryListUserArgs = {
  id?: Maybe<Scalars['String']>;
};


export type QuerySearchScheduledEventsArgs = {
  aggregates?: Maybe<Array<Maybe<SearchableScheduledEventAggregationInput>>>;
  filter?: Maybe<SearchableScheduledEventFilterInput>;
  from?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<SearchableScheduledEventSortInput>>>;
};

export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  assets?: Maybe<Array<Maybe<Asset>>>;
  backgroundUrl?: Maybe<Scalars['String']>;
  cid: Scalars['String'];
  client?: Maybe<Client>;
  createdAt: Scalars['AWSDateTime'];
  cronFlag?: Maybe<Scalars['Int']>;
  cueSheetUrl?: Maybe<Scalars['String']>;
  currentMuxStreamUrl?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['AWSDateTime']>;
  dateUpdated?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  destinations?: Array<Maybe<Destination>>;
  distributions: Array<Distribution>;
  eid: Scalars['String'];
  endTime: Scalars['AWSDateTime'];
  eventPassword?: Maybe<Scalars['String']>;
  eventType: EventType;
  hidden: Scalars['Boolean'];
  id: Scalars['String'];
  isLive: Scalars['Boolean'];
  isOperated?: Maybe<Scalars['Boolean']>;
  isSimulatedLive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  muxDashboardUrl?: Maybe<Scalars['String']>;
  muxIds?: Maybe<MuxIds>;
  muxStatus?: Maybe<Scalars['String']>;
  muxStreamUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationSent?: Maybe<Scalars['Boolean']>;
  operatorNotes?: Maybe<Scalars['String']>;
  organizationName: Scalars['String'];
  recordOnly: Scalars['Boolean'];
  simulatedLiveAssetId?: Maybe<Scalars['Int']>;
  simulatedLiveFilename?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['AWSDateTime']>;
  status: Scalars['String'];
  streamFacebook: Scalars['Boolean'];
  streamLive: Scalars['Boolean'];
  streamRtmp?: Maybe<Scalars['Boolean']>;
  streamYoutube: Scalars['Boolean'];
  streamZoom: Scalars['Boolean'];
  updatedAt: Scalars['AWSDateTime'];
  visibility: EventVisibility;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomPassword?: Maybe<Scalars['String']>;
};


export type ScheduledEventDestinationsArgs = {
  filter?: Maybe<ModelDestinationFilterInput>;
  limit?: Maybe<Scalars['Int']>;
  nextToken?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<ModelSortDirection>;
};

export type SearchableAggregateBucketResult = {
  __typename?: 'SearchableAggregateBucketResult';
  buckets?: Maybe<Array<Maybe<SearchableAggregateBucketResultItem>>>;
};

export type SearchableAggregateBucketResultItem = {
  __typename?: 'SearchableAggregateBucketResultItem';
  doc_count: Scalars['Int'];
  key: Scalars['String'];
};

export type SearchableAggregateGenericResult = SearchableAggregateBucketResult | SearchableAggregateScalarResult;

export type SearchableAggregateResult = {
  __typename?: 'SearchableAggregateResult';
  name: Scalars['String'];
  result?: Maybe<SearchableAggregateGenericResult>;
};

export type SearchableAggregateScalarResult = {
  __typename?: 'SearchableAggregateScalarResult';
  value: Scalars['Float'];
};

export enum SearchableAggregateType {
  Avg = 'avg',
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
  Terms = 'terms'
}

export type SearchableBooleanFilterInput = {
  eq?: Maybe<Scalars['Boolean']>;
  ne?: Maybe<Scalars['Boolean']>;
};

export type SearchableFloatFilterInput = {
  eq?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  ne?: Maybe<Scalars['Float']>;
  range?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type SearchableIdFilterInput = {
  eq?: Maybe<Scalars['ID']>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['ID']>;
  gte?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  lte?: Maybe<Scalars['ID']>;
  match?: Maybe<Scalars['ID']>;
  matchPhrase?: Maybe<Scalars['ID']>;
  matchPhrasePrefix?: Maybe<Scalars['ID']>;
  multiMatch?: Maybe<Scalars['ID']>;
  ne?: Maybe<Scalars['ID']>;
  range?: Maybe<Array<Maybe<Scalars['ID']>>>;
  regexp?: Maybe<Scalars['ID']>;
  wildcard?: Maybe<Scalars['ID']>;
};

export type SearchableIntFilterInput = {
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  ne?: Maybe<Scalars['Int']>;
  range?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export enum SearchableScheduledEventAggregateField {
  BackgroundUrl = 'backgroundUrl',
  Cid = 'cid',
  CreatedAt = 'createdAt',
  CronFlag = 'cronFlag',
  CueSheetUrl = 'cueSheetUrl',
  CurrentMuxStreamUrl = 'currentMuxStreamUrl',
  DateCreated = 'dateCreated',
  DateUpdated = 'dateUpdated',
  Description = 'description',
  Distributions = 'distributions',
  Eid = 'eid',
  EndTime = 'endTime',
  EventPassword = 'eventPassword',
  EventType = 'eventType',
  Hidden = 'hidden',
  Id = 'id',
  IsLive = 'isLive',
  IsOperated = 'isOperated',
  IsSimulatedLive = 'isSimulatedLive',
  LocationId = 'locationId',
  LocationName = 'locationName',
  MuxDashboardUrl = 'muxDashboardUrl',
  MuxStatus = 'muxStatus',
  MuxStreamUrl = 'muxStreamUrl',
  Name = 'name',
  NotificationSent = 'notificationSent',
  OperatorNotes = 'operatorNotes',
  OrganizationName = 'organizationName',
  RecordOnly = 'recordOnly',
  SimulatedLiveAssetId = 'simulatedLiveAssetId',
  SimulatedLiveFilename = 'simulatedLiveFilename',
  StartTime = 'startTime',
  Status = 'status',
  StreamFacebook = 'streamFacebook',
  StreamLive = 'streamLive',
  StreamRtmp = 'streamRtmp',
  StreamYoutube = 'streamYoutube',
  StreamZoom = 'streamZoom',
  UpdatedAt = 'updatedAt',
  Visibility = 'visibility',
  ZoomMeetingId = 'zoomMeetingId',
  ZoomPassword = 'zoomPassword'
}

export type SearchableScheduledEventAggregationInput = {
  field: SearchableScheduledEventAggregateField;
  name: Scalars['String'];
  type: SearchableAggregateType;
};

export type SearchableScheduledEventConnection = {
  __typename?: 'SearchableScheduledEventConnection';
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<ScheduledEvent>>;
  nextToken?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type SearchableScheduledEventFilterInput = {
  end_time_gte?: Maybe<Scalars['AWSDateTime']>;
  end_time_lte?: Maybe<Scalars['AWSDateTime']>;
  start_time_gte?: Maybe<Scalars['AWSDateTime']>;
  start_time_lte?: Maybe<Scalars['AWSDateTime']>;
  status?: 1 | 2 | 3;
  verifier_email?: Maybe<Scalars['String']>;
  // and?: Maybe<Array<Maybe<SearchableScheduledEventFilterInput>>>;
  // backgroundUrl?: Maybe<SearchableStringFilterInput>;
  // cid?: Maybe<SearchableStringFilterInput>;
  // createdAt?: Maybe<SearchableStringFilterInput>;
  // cronFlag?: Maybe<SearchableIntFilterInput>;
  // cueSheetUrl?: Maybe<SearchableStringFilterInput>;
  // currentMuxStreamUrl?: Maybe<SearchableStringFilterInput>;
  // dateCreated?: Maybe<SearchableStringFilterInput>;
  // dateUpdated?: Maybe<SearchableStringFilterInput>;
  // description?: Maybe<SearchableStringFilterInput>;
  // distributions?: Maybe<SearchableStringFilterInput>;
  // eid?: Maybe<SearchableStringFilterInput>;
  // endTime?: Maybe<SearchableStringFilterInput>;
  // eventPassword?: Maybe<SearchableStringFilterInput>;
  // eventType?: Maybe<SearchableStringFilterInput>;
  // hidden?: Maybe<SearchableBooleanFilterInput>;
  // id?: Maybe<SearchableStringFilterInput>;
  // isLive?: Maybe<SearchableBooleanFilterInput>;
  // isOperated?: Maybe<SearchableBooleanFilterInput>;
  // isSimulatedLive?: Maybe<SearchableBooleanFilterInput>;
  // locationId?: Maybe<SearchableStringFilterInput>;
  // locationName?: Maybe<SearchableStringFilterInput>;
  // muxDashboardUrl?: Maybe<SearchableStringFilterInput>;
  // muxStatus?: Maybe<SearchableStringFilterInput>;
  // muxStreamUrl?: Maybe<SearchableStringFilterInput>;
  // name?: Maybe<SearchableStringFilterInput>;
  // not?: Maybe<SearchableScheduledEventFilterInput>;
  // notificationSent?: Maybe<SearchableBooleanFilterInput>;
  // operatorNotes?: Maybe<SearchableStringFilterInput>;
  // or?: Maybe<Array<Maybe<SearchableScheduledEventFilterInput>>>;
  // organizationName?: Maybe<SearchableStringFilterInput>;
  // recordOnly?: Maybe<SearchableBooleanFilterInput>;
  // simulatedLiveAssetId?: Maybe<SearchableIntFilterInput>;
  // simulatedLiveFilename?: Maybe<SearchableStringFilterInput>;
  // startTime?: Maybe<SearchableStringFilterInput>;
  // status?: Maybe<SearchableStringFilterInput>;
  // streamFacebook?: Maybe<SearchableBooleanFilterInput>;
  // streamLive?: Maybe<SearchableBooleanFilterInput>;
  // streamRtmp?: Maybe<SearchableBooleanFilterInput>;
  // streamYoutube?: Maybe<SearchableBooleanFilterInput>;
  // streamZoom?: Maybe<SearchableBooleanFilterInput>;
  // updatedAt?: Maybe<SearchableStringFilterInput>;
  // visibility?: Maybe<SearchableStringFilterInput>;
  // zoomMeetingId?: Maybe<SearchableStringFilterInput>;
  // zoomPassword?: Maybe<SearchableStringFilterInput>;
};

export type SearchableScheduledEventSortInput = {
  direction?: Maybe<SearchableSortDirection>;
  field?: Maybe<SearchableScheduledEventSortableFields>;
};

export type GetEventsInput = {
  end_time_gte?: Maybe<Scalars['AWSDateTime']>;
  end_time_lte?: Maybe<Scalars['AWSDateTime']>;
  event_type?: Maybe<EventType>;
  id?: Maybe<Scalars['Float']>;
  ids?: Maybe<Array<Scalars['Float']>>
  limit?: Maybe<Scalars['Float']>;
  location_id?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Float']>;
  sort_direction?: Maybe<SearchableSortDirection>;
  sort_field?: Maybe<SearchableScheduledEventSortableFields>;
  start_time_gte?: Maybe<Scalars['AWSDateTime']>;
  start_time_lte?: Maybe<Scalars['AWSDateTime']>;
  wildcard?: Maybe<Scalars['String']>;
}

export enum SearchableScheduledEventSortableFields {
  // BackgroundUrl = 'backgroundUrl',
  Cid = 'cid',
  // CreatedAt = 'createdAt',
  // CronFlag = 'cronFlag',
  // CueSheetUrl = 'cueSheetUrl',
  // CurrentMuxStreamUrl = 'currentMuxStreamUrl',
  // DateCreated = 'dateCreated',
  // DateUpdated = 'dateUpdated',
  // Description = 'description',
  Eid = 'eid',
  // EndTime = 'endTime',
  // EventPassword = 'eventPassword',
  // Hidden = 'hidden',
  // Id = 'id',
  // IsLive = 'isLive',
  // IsOperated = 'isOperated',
  // IsSimulatedLive = 'isSimulatedLive',
  // LocationId = 'locationId',
  // LocationName = 'locationName',
  // MuxDashboardUrl = 'muxDashboardUrl',
  // MuxStatus = 'muxStatus',
  // MuxStreamUrl = 'muxStreamUrl',
  // Name = 'name',
  // NotificationSent = 'notificationSent',
  // OperatorNotes = 'operatorNotes',
  OrganizationName = 'organizationName',
  // RecordOnly = 'recordOnly',
  // SimulatedLiveAssetId = 'simulatedLiveAssetId',
  // SimulatedLiveFilename = 'simulatedLiveFilename',
  StartTime = 'startTime',
  // Status = 'status',
  // StreamFacebook = 'streamFacebook',
  // StreamLive = 'streamLive',
  // StreamRtmp = 'streamRtmp',
  // StreamYoutube = 'streamYoutube',
  // StreamZoom = 'streamZoom',
  // UpdatedAt = 'updatedAt',
  // ZoomMeetingId = 'zoomMeetingId',
  // ZoomPassword = 'zoomPassword'
}

export enum SearchableSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SearchableStringFilterInput = {
  eq?: Maybe<Scalars['String']>;
  exists?: Maybe<Scalars['Boolean']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  match?: Maybe<Scalars['String']>;
  matchPhrase?: Maybe<Scalars['String']>;
  matchPhrasePrefix?: Maybe<Scalars['String']>;
  multiMatch?: Maybe<Scalars['String']>;
  ne?: Maybe<Scalars['String']>;
  range?: Maybe<Array<Maybe<Scalars['String']>>>;
  regexp?: Maybe<Scalars['String']>;
  wildcard?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onAirtableUpsert?: Maybe<Airtable>;
  onCreateDestination?: Maybe<Destination>;
  onCreateScheduledEvent?: Maybe<ScheduledEvent>;
  onDeleteDestination?: Maybe<Destination>;
  onDeleteScheduledEvent?: Maybe<ScheduledEvent>;
  onUpdateDestination?: Maybe<Destination>;
  onUpdateScheduledEvent?: Maybe<ScheduledEvent>;
  onUpdateScheduledEventByEid?: Maybe<ScheduledEvent>;
  onUserDelete?: Maybe<CognitoUserDeleted>;
  onUserUpsert?: Maybe<User>;
};


export type SubscriptionOnUpdateScheduledEventByEidArgs = {
  eid?: Maybe<Scalars['String']>;
};

export type SuccessType = {
  __typename?: 'SuccessType';
  success?: Maybe<Scalars['Boolean']>;
};

export type TroubleshootingContact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  updated_at?: Maybe<Scalars['AWSDateTime']>;
  type?: Maybe<{type: Scalars['String']; id?: Maybe<Scalars['ID']>}>;
  created_at?: Maybe<Scalars['AWSDateTime']>;
  priority?: Maybe<Scalars['Float']>;
  preferred_contact_method?: Maybe<Scalars['String']>;
  phone_type?: Maybe<Scalars['String']>;
  location?: Maybe<any>;
  address?: Maybe<Scalars['String']>;
};

export type TroubleshootingContactInput = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type UpdateDestinationInput = {
  active?: Maybe<Scalars['Boolean']>;
  destinationPlayerUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  integrationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  scheduledEventDestinationsId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  streamBroadcastId?: Maybe<Scalars['String']>;
  streamKey?: Maybe<Scalars['String']>;
  streamPassthrough?: Maybe<Scalars['String']>;
  streamSecondaryBroadcastId?: Maybe<Scalars['String']>;
  streamUrl?: Maybe<Scalars['String']>;
  type?: Maybe<DestinationType>;
};

export type UpdateScheduledEventInput = {
  assets?: Maybe<Array<Maybe<AssetInput>>>;
  backgroundUrl?: Maybe<Scalars['String']>;
  cid?: Maybe<Scalars['String']>;
  client?: Maybe<ClientInput>;
  cronFlag?: Maybe<Scalars['Int']>;
  cueSheetUrl?: Maybe<Scalars['String']>;
  currentMuxStreamUrl?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['AWSDateTime']>;
  dateUpdated?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  distributions?: Maybe<Array<Distribution>>;
  eid: Scalars['String'];
  endTime?: Maybe<Scalars['AWSDateTime']>;
  eventPassword?: Maybe<Scalars['String']>;
  eventType?: Maybe<EventType>;
  hidden?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  isOperated?: Maybe<Scalars['Boolean']>;
  isSimulatedLive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  muxDashboardUrl?: Maybe<Scalars['String']>;
  muxIds?: Maybe<MuxIdsInput>;
  muxStatus?: Maybe<Scalars['String']>;
  muxStreamUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationSent?: Maybe<Scalars['Boolean']>;
  operatorNotes?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  recordOnly?: Maybe<Scalars['Boolean']>;
  simulatedLiveAssetId?: Maybe<Scalars['Int']>;
  simulatedLiveFilename?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['AWSDateTime']>;
  status?: Maybe<Scalars['String']>;
  streamFacebook?: Maybe<Scalars['Boolean']>;
  streamLive?: Maybe<Scalars['Boolean']>;
  streamRtmp?: Maybe<Scalars['Boolean']>;
  streamYoutube?: Maybe<Scalars['Boolean']>;
  streamZoom?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<EventVisibility>;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomPassword?: Maybe<Scalars['String']>;
};

export type UpdateUser = {
  forceResetPassword?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type UpsertAirtableInput = {
  assignedOperator?: Maybe<Scalars['String']>;
  cueSheetUrl?: Maybe<Scalars['String']>;
  eventId: Scalars['Int'];
  eventOperatorNotes?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  operatorNotes?: Maybe<Scalars['String']>;
  operatorType?: Maybe<Scalars['String']>;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomPassword?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'Users';
  createdAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  // emailVerified: Scalars['Boolean'];
  // groups: Array<Group>;
  id: Scalars['String'];
  // masqueradeToken: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  phone_number: Scalars['String'];
  // phoneVerified: Scalars['Boolean'];
  // status: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
  // username: Scalars['String'];
  updated_at?: Maybe<any>;
  time_zone: string;
  subscription_status?: Maybe<boolean>;
  stripeBillingPortal?: Maybe<string>;
  status?: Maybe<{
    status?: Maybe<string>;
    id?: number;
  }>;
  splashtop_email?: Maybe<string>;
  role?: Maybe<{
    role?: Maybe<string>;
    id?: string;
  }>;
  profile_picture?: Maybe<string>;
  payment_token?: Maybe<string>;
  password_reset?: Maybe<{
    token: string;
    id: string;
    expiry: any;
    email: string;
  }>;
  organization_zip_code?: Maybe<string>;
  organization_name?: Maybe<string>;
  organization_address?: Maybe<string>;
  notes?: Maybe<string>;
  locations?: Array<any>;
  lead_time?: Maybe<number>;
  last_login?: Maybe<any>;
  events_to_operate?: Array<any>;
  event_operator_notes?: Maybe<string>;
  enable_produced_event_contact: boolean;
  enable_email_notifications?: Maybe<boolean>;
  email_verification_token?: Maybe<{
    updated_at: any;
    token: string;
    id: string;
    created_at: any;
  }>;
  emailNotifications?: Maybe<{
    user: User;
    id: string;
    event_scheduling: boolean;
    event_reminder: boolean;
    customer_feedback: boolean;
    connection_issues: boolean;
  }>;
  created_at?: Maybe<any>;
  contacts?: Array<TroubleshootingContact>;
  command_center_access?: Maybe<boolean>;
};
